import {
  getDepartments as getDepartmentsService,
  createDepartment as createDepartmentService,
  updateDepartmentStatus as updateDepartmentStatusService,
  updateDepartment as updateDepartmentService,
} from "services/company/department/departmentService";
import {
  getDepartmentsStart,
  getDepartmentsSuccess,
  getDepartmentsFailure,
  createDepartmentStart,
  createDepartmentSuccess,
  createDepartmentFailure,
  updateDepartmentStart,
  updateDepartmentSuccess,
  updateDepartmentFailure,
  updateDepartmentStatusStart,
  updateDepartmentStatusSuccess,
  updateDepartmentStatusFailure,
} from "./departmentSlice";
import { showSuccessToast, showErrorToast } from "utils/toastNotification";

// Fetch all departments
export const fetchDepartments = () => async (dispatch) => {
  try {
    dispatch(getDepartmentsStart());
    const response = await getDepartmentsService();

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(getDepartmentsSuccess(response.data));
      return { success: true, data: response.data };
    } else {
      const errorMsg = response?.meta?.message || "Failed to fetch departments";
      dispatch(getDepartmentsFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Fetch departments error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to fetch departments";
    dispatch(getDepartmentsFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

// Create a new department
export const createNewDepartment = (departmentData) => async (dispatch) => {
  try {
    dispatch(createDepartmentStart());
    const response = await createDepartmentService(departmentData);

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      // After successful creation, fetch the updated list
      await dispatch(fetchDepartments());
      dispatch(createDepartmentSuccess(response.data));
      showSuccessToast(
        response?.meta?.message || "Department created successfully!",
      );
      return { success: true, data: response.data };
    } else {
      const errorMsg = response?.meta?.message || "Failed to create department";
      dispatch(createDepartmentFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Create department error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to create department";
    dispatch(createDepartmentFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

// Update status
export const toggleDepartmentStatus =
  (departmentId, currentStatus) => async (dispatch) => {
    try {
      dispatch(updateDepartmentStatusStart());
      const newStatus = currentStatus === "active" ? "inactive" : "active";
      const response = await updateDepartmentStatusService(
        departmentId,
        newStatus,
      );

      if (response?.meta?.status === true && response?.meta?.code === 200) {
        dispatch(
          updateDepartmentStatusSuccess({
            id: departmentId,
            status: newStatus,
          }),
        );
        showSuccessToast(
          response?.meta?.message ||
            `Department ${
              newStatus === "active" ? "activated" : "inactivated"
            } successfully!`,
        );
        return { success: true };
      } else {
        const errorMsg =
          response?.meta?.message || "Failed to update department status";
        dispatch(updateDepartmentStatusFailure(errorMsg));
        showErrorToast(errorMsg);
        return { success: false, error: errorMsg };
      }
    } catch (error) {
      console.error("Update department status error:", error);
      const errorMsg =
        error?.response?.data?.meta?.message ||
        error.message ||
        "Failed to update department status";
      dispatch(updateDepartmentStatusFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  };
// Update a department
export const updateExistingDepartment =
  (departmentId, departmentData) => async (dispatch) => {
    try {
      dispatch(updateDepartmentStart());
      const response = await updateDepartmentService(
        departmentId,
        departmentData,
      );

      if (response?.meta?.status === true && response?.meta?.code === 200) {
        // After successful update, fetch the updated list
        await dispatch(fetchDepartments());
        dispatch(
          updateDepartmentSuccess({ id: departmentId, ...departmentData }),
        );
        showSuccessToast(
          response?.meta?.message || "Department updated successfully!",
        );
        return { success: true, data: response.data };
      } else {
        const errorMsg =
          response?.meta?.message || "Failed to update department";
        dispatch(updateDepartmentFailure(errorMsg));
        showErrorToast(errorMsg);
        return { success: false, error: errorMsg };
      }
    } catch (error) {
      console.error("Update department error:", error);
      const errorMsg =
        error?.response?.data?.meta?.message ||
        error.message ||
        "Failed to update department";
      dispatch(updateDepartmentFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  };
